// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"280":"e9575d40","791":"6778e6ea","884":"4a67cdef"}[chunkId] + ".chunk.css";
};